import { Formik } from "formik";
import { isEmpty } from "lodash-es";

import {
  Form,
  SubmitButton,
  TextInput,
  ButtonGroup,
  InputAlert,
  AlertType,
} from "lcm-iot-commons";
import validator from "validator";
import { useIntl } from "react-intl";
import Captcha from "../Captcha/Captcha";
import PasswordInput from "../Form/PasswordInput";

const ENDRESS_DOMAIN_RE = /@([a-z0-9-]+\.)*endress\.com$/i;
const isEndressEmail = (email?: string) =>
  !!email && ENDRESS_DOMAIN_RE.test(email);

type OwnProps = {
  onSubmit: $TSFixMeFunction;
  captchaRequired?: boolean;
  captchaRefresh?: $TSFixMe;
  showEndressWarning?: boolean;
};

const defaultProps: Partial<OwnProps> = {
  captchaRequired: false,
  captchaRefresh: undefined,
  showEndressWarning: false,
};

type Props = OwnProps & typeof defaultProps;

export default function SignInForm({
  onSubmit,
  captchaRequired,
  captchaRefresh,
  showEndressWarning,
}: Props) {
  const intl = useIntl();

  const validateForm = (values: $TSFixMe) => {
    const errors = {};

    if (isEmpty(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.mandatory",
      });
    } else if (!validator.isEmail(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.invalid",
      });
    }
    if (isEmpty(values.password)) {
      (errors as $TSFixMe).password = intl.formatMessage({
        id: "validation.password.mandatory",
      });
    }
    if (captchaRequired && isEmpty(values.captcha)) {
      (errors as $TSFixMe).captcha = intl.formatMessage({
        id: "validation.captcha.mandatory",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;

    const showWarning =
      showEndressWarning && isEndressEmail(formProps.values?.email);

    return (
      <Form {...formProps}>
        <TextInput
          {...formProps}
          id="email"
          name="email"
          label={intl.formatMessage({ id: "label.email" })}
          required
          autoFocus
          autoCorrect="off"
          autoComplete="username"
        />
        <PasswordInput
          {...formProps}
          id="password"
          name="password"
          label={intl.formatMessage({ id: "label.password" })}
          autoComplete="current-password"
          checkPassword={false}
          required
        />
        {captchaRequired ? (
          <Captcha {...formProps} name="captcha" ref={captchaRefresh} />
        ) : null}
        {showWarning ? (
          <InputAlert
            dataTestId="endress-domain-warning"
            type={AlertType.WARNING}
            message={intl.formatMessage({
              id: "signin.endress_domain_warning",
            })}
          />
        ) : null}
        <ButtonGroup>
          <SubmitButton
            id="sign-in"
            text={intl.formatMessage({ id: "signin.button.signin" })}
            fetching={isSubmitting}
            hero={false}
          />
        </ButtonGroup>
      </Form>
    );
  };

  return (
    <Formik
      validateOnBlur={false}
      id="sign-in-form"
      onSubmit={onSubmit}
      validate={validateForm}
      initialValues={{}}
    >
      {renderForm}
    </Formik>
  );
}
SignInForm.defaultProps = defaultProps;
